import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  generateSkipMap,
  mapQuestionIdToQuestionNumber,
} from '../utils/assessmentsSkiplogic.utils';
import { setSkipLogicMap, setQuestionIdToNumberMap } from '../assessmentsSlice';
import { useAssessmentsQuestions } from './useAssessmentsQuestions';

export const useAssessmentInitialiseSkipLogic = () => {
  const dispatch = useDispatch();

  const { questions } = useAssessmentsQuestions();

  useEffect(() => {
    const generatedSkipMap = generateSkipMap(questions ?? []);
    const generatedQuestionIdToNumberMap = mapQuestionIdToQuestionNumber(questions ?? []);
    dispatch(setSkipLogicMap(generatedSkipMap));
    dispatch(setQuestionIdToNumberMap(generatedQuestionIdToNumberMap));
  }, [questions, dispatch]);
};
